var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg100Gold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 136.69872 60.4351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6.4351px;\n      }\n\n      .cls-2 {\n        fill: url(#Gold);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gold",
    x1: 68.34936,
    y1: 8.31469,
    x2: 68.34936,
    y2: 45.28912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00562,
    stopColor: "#fccb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25281,
    stopColor: "#fffad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29822,
    stopColor: "#faf1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38847,
    stopColor: "#edd894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51382,
    stopColor: "#d8b14c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59551,
    stopColor: "#c9961a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81418,
    stopColor: "#e9cd76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87079,
    stopColor: "#f2dc8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffad2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "draw"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.66688,48.3795h8.46334a2.45978,2.45978,0,0,0,2.322-2.77137v-26.438A48.882,48.882,0,0,1,3.21755,20.2935V13.55283c8.08943-.59937,13.706-.97328,16.1773-9.66129h9.66207v41.642c0,1.4226.44933,2.846,2.47129,2.846h7.93862v7.63932H3.66688ZM63.76027,3.21755c16.402,0,20.89679,12.58191,20.89679,26.438,0,16.77666-4.94416,27.56205-22.02011,27.56205-18.49934,0-20.82138-16.028-20.82138-28.31066C41.81557,15.05084,46.909,3.21755,63.76027,3.21755Zm-6.29056,19.7719V40.06619c0,3.67.74782,9.51125,5.692,9.51125,4.26859,0,5.76739-3.44457,5.76739-9.212,0-6.66526.14926-11.75867.14926-17.30062,0-4.194-.07542-12.05874-5.61658-12.05874C58.81768,11.00612,57.46971,14.15219,57.46971,22.98945Zm55.11467-19.7719c16.402,0,20.89679,12.58191,20.89679,26.438,0,16.77666-4.94416,27.56205-22.0201,27.56205-18.49934,0-20.82138-16.028-20.82138-28.31066C90.63969,15.05084,95.73309,3.21755,112.58438,3.21755Zm-6.29056,19.7719V40.06619c0,3.67.74783,9.51125,5.692,9.51125,4.2686,0,5.7674-3.44457,5.7674-9.212,0-6.66526.14925-11.75867.14925-17.30062,0-4.194-.07541-12.05874-5.61657-12.05874C107.6418,11.00612,106.29382,14.15219,106.29382,22.98945Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.66688,48.3795h8.46334a2.45978,2.45978,0,0,0,2.322-2.77137v-26.438A48.882,48.882,0,0,1,3.21755,20.2935V13.55283c8.08943-.59937,13.706-.97328,16.1773-9.66129h9.66207v41.642c0,1.4226.44933,2.846,2.47129,2.846h7.93862v7.63932H3.66688ZM63.76027,3.21755c16.402,0,20.89679,12.58191,20.89679,26.438,0,16.77666-4.94416,27.56205-22.02011,27.56205-18.49934,0-20.82138-16.028-20.82138-28.31066C41.81557,15.05084,46.909,3.21755,63.76027,3.21755Zm-6.29056,19.7719V40.06619c0,3.67.74782,9.51125,5.692,9.51125,4.26859,0,5.76739-3.44457,5.76739-9.212,0-6.66526.14926-11.75867.14926-17.30062,0-4.194-.07542-12.05874-5.61658-12.05874C58.81768,11.00612,57.46971,14.15219,57.46971,22.98945Zm55.11467-19.7719c16.402,0,20.89679,12.58191,20.89679,26.438,0,16.77666-4.94416,27.56205-22.0201,27.56205-18.49934,0-20.82138-16.028-20.82138-28.31066C90.63969,15.05084,95.73309,3.21755,112.58438,3.21755Zm-6.29056,19.7719V40.06619c0,3.67.74783,9.51125,5.692,9.51125,4.2686,0,5.7674-3.44457,5.7674-9.212,0-6.66526.14925-11.75867.14925-17.30062,0-4.194-.07541-12.05874-5.61657-12.05874C107.6418,11.00612,106.29382,14.15219,106.29382,22.98945Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg100Gold);
export default __webpack_public_path__ + "static/media/100-gold.522000f80575e77ad87a35c278905898.svg";
export { ForwardRef as ReactComponent };